export default "__VITE_ASSET__b86b128b__"